import React from 'react';
import { Link } from 'react-router-dom';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Plus, FileText, AlertCircle } from 'lucide-react';
import { toPersianDigits } from '../../utils/persian';
export function ClaimsPage() {
  return <CustomerLayout data-id="element-314">
      <div className="space-y-6" data-id="element-315">
        <div className="flex justify-between items-center" data-id="element-316">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-317">پرونده‌های خسارت</h1>
          <Link to="/claims/new" data-id="element-318">
            <Button data-id="element-319">
              <Plus className="ml-2 h-4 w-4" data-id="element-320" />
              ثبت خسارت جدید
            </Button>
          </Link>
        </div>

        {/* Empty State */}
        <div className="text-center py-12 bg-white rounded-lg border border-dashed border-gray-300" data-id="element-321">
          <div className="inline-flex items-center justify-center p-4 bg-gray-50 rounded-full text-gray-400 mb-4" data-id="element-322">
            <FileText className="h-8 w-8" data-id="element-323" />
          </div>
          <h3 className="text-lg font-medium text-gray-900" data-id="element-324">
            هیچ پرونده‌ای یافت نشد
          </h3>
          <p className="text-gray-500 mt-2 max-w-sm mx-auto" data-id="element-325">
            شما تاکنون درخواست خسارتی ثبت نکرده‌اید. در صورت بروز حادثه،
            می‌توانید از دکمه بالا استفاده کنید.
          </p>
        </div>

        {/* Example of a claim card (commented out for empty state demo, but ready to use) */}
        {/*
         <Card className="hover:shadow-md transition-shadow">
          <CardContent className="p-6">
            <div className="flex flex-col md:flex-row justify-between items-start gap-4">
              <div className="flex items-center gap-4">
                <div className="h-12 w-12 rounded-lg bg-red-100 flex items-center justify-center text-red-600">
                  <AlertCircle className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">تصادف خودرو ۲۰۶</h3>
                  <p className="text-sm text-gray-500">کد پیگیری: {toPersianDigits('987654')}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                <div className="text-left pl-4 border-l">
                  <span className="block text-xs text-gray-400">تاریخ حادثه</span>
                  <span className="text-sm font-medium">{toPersianDigits('1403/02/15')}</span>
                </div>
                <Badge variant="warning">در حال بررسی</Badge>
                <Button variant="outline" size="sm">مشاهده جزئیات</Button>
              </div>
            </div>
          </CardContent>
         </Card>
         */}
      </div>
    </CustomerLayout>;
}